{parse} = require('src/js/i18n/conversion')

$.fn.dataTable.ext.type.order['num-pre'] = (number) ->
    if typeof(number) is 'number' then number else parse(number, 'number')
